<template>
  <div class="footerView">
    <div class="footer_contentView">
      <div class="footer_contentView_t">
        <div class="footer_contentView_l">
          <div class="footer_list" v-for="group in toolItems" :key="group.title" @click="navBtnTouch(group.path)">
            {{ group.title == '代理合作'?'':group.title }}
            <a v-if="group.title == '代理合作'" href="tel:400-0519-000">代理合作</a>
          </div>
        </div>
        <div class="footer_contentView_r">
          <span>4000-519-000</span>
          <div class="QRCode"></div>
        </div>
      </div>
      <div class="footer_contentView_b">
        <div class="copyright">
          <div @click="pushUrl">{{recordsCode}}</div>
          <div>海南掌上能量传媒有限公司</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      recordsCode:'琼ICP备20001387号',
      toolItems:[
        {
          title: '产品中心',
          path:'product'
        },{
          title: '代理合作',
          path:''
        },{
          title: '服务与支持',
          path:'trends'
        },{
          title: '关于我们',
          path:'strength'
        },{
          title: '联系我们',
          path:'strength'
        }
      ]
    };
  },
  components: {},
  mounted() {
    // if(window.location.host.indexOf("vsulv.com") != -1){
    //   this.recordsCode = "琼ICP备20001387号-1"
    // }else{
    //   this.recordsCode = "琼ICP备20001387号-2"
    // }
  },
  methods: {
    navBtnTouch(path){
      const route = this.$route;
      const pathArr = route.path.split("/");
      if(pathArr[1] == path){
        window.scrollTo(0, 0);
      }else{
        this.$router.push(path);
      }
    },
    pushUrl() {
      window.open("https://beian.miit.gov.cn/#/home","_blank")
    },
  },
};
</script>

<style lang='scss' scoped>
a{
  color: #FEFFFF;
  text-decoration:none;
}
.footerView {
  display: flex;
  justify-content: center;
  background-color: #232627;
  color: #FEFFFF;
  font-size: 0.12rem;
  font-weight: 500;
  width: 100%;
}
.footer_contentView {
  width: 90%;
  margin: 0.2rem auto;
}
.footer_contentView_t {
  display: flex;
  justify-content: space-between;
}
.footer_contentView_l {
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.1rem;
  width: calc(100% - 1.6rem);
}
.footer_list {
  text-align: left;
  margin-right: 0.4rem;
  // width: 0.6rem;
}
.footer_list div {
  margin-top: 16px;
  color: #C4C5C7;
}
.footer_contentView_r {
  font-size: 0.2rem;
  font-weight: 600;
  width: 1.5rem;
  text-align: center;
}
.QRCode{
  width: 0.8rem;
  height: 0.8rem;
  background-image: url("../assets/img/code.jpg");
  background-size: 100% 100%;
  margin: 0.05rem auto;
}
.footer_contentView_b {
  color: #C4C5C7;
  margin-top: 0.1rem;
}
.copyright {
  text-align: center;
  border-top: 1px solid #3d4242;
  div{
    font-size: 0.13rem;
    width: 200px;
    height: 0.25rem;
    line-height: 0.25rem;
    margin: 0 auto;
  }
}
</style>